export default {"src":"/_next/static/media/clouds1.acc78f98.svg","height":102,"width":163,"blurWidth":0,"blurHeight":0};